export const AppUrl = {
  EnterCode: '/ingresar-codigo',
  PaymentStatus: '/estado-pago',
  PaymentSummary: '/resumen-pago',
  PendingAccounts: '/cuentas-pendientes',
  Root: '/'
};
